import { percentOf } from '../../../platform/percentOf'

/**
 * The assets-vs-debt meter's fill: assets / (assets + debt), a whole percent in
 * [0, 100]. For drawing only — it is never rendered as money, and is shown to
 * assistive tech only as the meter's percent value.
 *
 * Overdrawn (negative) inputs clamp to 0 first, so the share stays in range.
 * `null` when both are zero: there is nothing to compare, and the caller hides
 * the meter rather than draw an empty track that reads as "all debt".
 */
export function assetShare(assetsCents: number, debtCents: number): number | null {
  const assets = Math.max(0, assetsCents)
  const debt = Math.max(0, debtCents)
  const total = assets + debt
  if (total === 0) return null
  return percentOf(assets, total)
}
